import React from "react";
import { NavLink, Outlet } from "react-router-dom";
import "./Dashboard.css";

export default function DashboardLayout() {
  return (
    <div className="dashboard-container">
      {/* Sidebar */}
      <aside className="dashboard-sidebar">
        <h2 className="dashboard-logo">CMS Panel</h2>
        <nav className="dashboard-nav">
          <NavLink to="/cms" end className="dashboard-link">
             داشبورد
          </NavLink>
          <NavLink to="/cms/manage-blogs" className="dashboard-link">
             مدیریت بلاگ‌ها
          </NavLink>
          <NavLink to="/cms/add-blog" className="dashboard-link">
             افزودن بلاگ
          </NavLink>
          <NavLink to="/cms/user-management" className="dashboard-link">
             مدیریت کاربران
          </NavLink>
          <NavLink to="/cms/add-product" className="dashboard-link">
             افزودن محصول
          </NavLink>          
          
          <NavLink to="/cms/products" className="dashboard-link">
             مدیریت محصولات
          </NavLink>                   
          <NavLink to="/cms/categories" className="dashboard-link">
             مدیریت دسته‌بندی‌ها
          </NavLink>          
          
          <NavLink to="/cms/orders" className="dashboard-link">
             مدیریت سفارش‌ها
          </NavLink>  

         <NavLink to="/cms/comment-management" className="dashboard-link">
               مدیریت نظرات
         </NavLink>

        </nav>
      </aside>

      {/* Main content */}
      <main className="dashboard-main">
        <Outlet /> {/* React Router will render the selected page here */}
      </main>
    </div>
  );
}
